import React, { useRef } from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './Upload.less';
import cx from 'classnames';
import {
  useUploadCoverMutation,
  useUpdateCardCoverMutation,
} from '@trello/graphql/generated';
import { track } from '@trello/analytics';

const format = forTemplate('card_cover_chooser');

interface UploadProps {
  onFileUploaded: () => void;
  cardId: string;
  onFileSelected: () => void;
}

export const Upload: React.FunctionComponent<UploadProps> = ({
  cardId,
  onFileSelected,
  onFileUploaded,
}) => {
  const [uploadCover] = useUploadCoverMutation();
  const [updateCardCover] = useUpdateCardCoverMutation();

  const uploadFile = async (file: File) => {
    const response = await uploadCover({
      variables: {
        cardId,
        file,
      },
    });

    return (
      (response && response.data && response.data.uploadCardAttachment) ||
      undefined
    );
  };

  const setCover = async (cover: { idAttachment: string }) => {
    await updateCardCover({
      variables: {
        cardId,
        cover,
      },
    });
  };

  const fileInput = useRef<HTMLInputElement>(null);

  return (
    <div>
      <h4 className={styles.heading}>{format('upload')}</h4>
      <input
        ref={fileInput}
        className={styles.fileInput}
        type="file"
        accept="image/*"
        onChange={async (e) => {
          const input = e.currentTarget;
          const file = input.files && input.files[0];
          if (file) {
            onFileSelected();
            const attachment = await uploadFile(file);
            if (attachment) {
              await setCover({
                idAttachment: attachment.id,
              });
              track('Card Cover Chooser', 'Set cover to an upload');
            }
            onFileUploaded();
          }
        }}
      />

      <button
        className={cx('button', styles.upload)}
        onClick={() => {
          fileInput.current && fileInput.current.click();
          track('Card Cover Chooser', 'Clicked Upload');
        }}
      >
        {format('upload-a-cover-image')}
      </button>
      <div className={styles.tip}>{format('tip-drag-an-image')}</div>
    </div>
  );
};
